export default {
    config: {
        shareUrl: {
            default: {
                baseUrl: 'https://connect.mail.ru/share',
                params: {
                    url: 'url',
                    title: 'title',
                    description: 'description'
                }
            }
        }
    },

    popupDimensions: [560, 400],

    i18n: {
        az: 'Moy Mir',
        be: 'ÐœÐ¾Ð¹ ÐœÐ¸Ñ€',
        en: 'Moi Mir',
        hy: 'Moi Mir',
        ka: 'Moi Mir',
        kk: 'ÐœÐ¾Ð¹ ÐœÐ¸Ñ€',
        ro: 'Moi Mir',
        ru: 'ÐœÐ¾Ð¹ ÐœÐ¸Ñ€',
        tr: 'Moi Mir',
        tt: 'ÐœÐ¾Ð¹ ÐœÐ¸Ñ€',
        uk: 'ÐœÐ¾Ð¹ ÐœÐ¸Ñ€',
        uz: 'Moy Mir'
    },

    color: '#168de2'
};
